import { useCallback } from "react";
import { toast } from "sonner";
import axios, { API, authed, apiError } from "@/lib/api";

export const useAdminAction = (getToken, onDone) =>
  useCallback(async (method, path, body) => {
    try {
      const r = await axios({ method, url: `${API}${path}`, data: body, ...(await authed(getToken)) });
      toast.success(r.data.email_sent === false ? "Fait (e-mail non envoyé)" : r.data.email_sent ? "Fait — le client a été prévenu par e-mail" : "Fait");
      onDone?.();
      return true;
    } catch (e) { toast.error(apiError(e)); return false; }
  }, [getToken, onDone]);
